
        var result = require("!!../../../../node_modules/css-loader/index.js!./singlemember.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/singleMember-form/singlemember.component.css
// module id = 627
// module chunks = 0